{
  "import_layer": {
    "title": "Importar uma camada",
    "confirm": "Importar camadas"
  },
  "data_fields": {
    "title": "Atributos",
    "add": "Adicionar atributo",
    "project_data_fields": "Atributo predefinido",
    "custom_data_field": "Atributo personalizado",
    "type": "Tipo",
    "name": "Nome do atributo",
    "list_name": "Nome da lista",
    "list_items": "Listar itens",
    "list_item": "Item da lista",
    "types": {
      "Text": "Texto",
      "List": "Lista",
      "Number": "Número",
      "Date": "Data",
      "Tickbox": "Marque a caixa",
      "Time": "Hora",
      "TimeRange": "Intervalo de tempo",
      "Image": "Imagem",
      "Hyperlink": "Hiperlink",
      "RepeatedTimeRanges": "Intervalos de data e hora"
    },
    "data_driven_formula": {
      "title": "Crie uma nova fórmula",
      "label": "Determine {{ styleProperty }} por",
      "addListItem": "Adicionar item da lista",
      "searchListItem": "Pesquisar um item da lista"
    }
  },
  "saved_map_view": {
    "default_label": "Torne essa a visualização padrão do plano.",
    "default_description": "Isso define a imagem em miniatura do plano e carrega essa visualização para todos os usuários quando eles abrem o plano.",
    "form_header": "Nomeie esta visualização salva",
    "name_label": "Nome da visualização salva",
    "create_saved_view": "Criar uma visualização salva",
    "create_new_saved_view": "Criar uma nova visualização salva",
    "edit_saved_view": "Editar a visualização salva",
    "move_map_around": "Mova o plano até ficar satisfeito com a nova visualização.",
    "save_view_when_ready": "Quando estiver pronto, toque em “Salvar alterações” para salvar a visualização.",
    "map_default": "plano padrão"
  },
  "create_map": {
    "create_map": "Criar plano",
    "create_a_map": "Crie um plano",
    "modal_label": "Nome do plano",
    "create_a_new_map": "Crie um novo plano"
  },
  "buttons": {
    "new_layer": "Nova camada",
    "import_layer": "Camada de importação",
    "site_map": "Mapa do site",
    "background": "Plano de fundo",
    "create_layer": "Criar camada",
    "cancel": "Cancelar",
    "share_table": "Compartilhar tabela",
    "download_table": "Baixar tabela",
    "toggle_sidebar": "Alternar barra lateral",
    "columns_displayed": "Colunas exibidas",
    "closePopup": "Fechar pop-up",
    "openBasemapSelector": "Abrir seletor de mapa base",
    "removeSiteMap": "Remover mapa do site da visualização"
  },
  "labels": {
    "object": "Objeto",
    "object_id": "ID do objeto",
    "object_name": "Nome do objeto",
    "layer": "Camada",
    "zone": "Zona",
    "zones": "Zonas",
    "client_group": "Grupo de clientes"
  },
  "nav": {
    "layers": "camadas",
    "data_table": "Tabela de dados",
    "sitemap": "Mapa do site",
    "background": "Plano de fundo",
    "basemap": "Mapa base",
    "background_maps": "Mapas de fundo",
    "selectSitemap": "Selecione o mapa do site",
    "selectLevel": "Selecione o nível",
    "search": "Pesquisar"
  },
  "popup": {
    "view_by_layer": "Exibir por camada",
    "view_by_data_field": "Exibir por campo de dados",
    "view_by_object": "Exibir por objeto",
    "sitemapsAvailableAtThisLocation": "Sitemaps disponíveis neste local",
    "closeSitemapSelector": "Fechar seletor de mapa do site",
    "sitemapLevels": "Níveis do mapa do site",
    "closeLevelSelector": "Fechar seletor de nível",
    "saved_map_views": "Visualizações salvas"
  },
  "add_layer": {
    "create_a_new_layer": "Crie uma nova camada",
    "new_layer": "Nova camada",
    "name_of_layer": "Nome da camada",
    "layer_style": "Estilo de camada",
    "layer_style_desc": "Escolha um tipo de desenho ou selecione um modelo de estilo",
    "drawing_type": "Tipo de desenho",
    "area": "Área",
    "lines": "Linhas",
    "points": "Pontos",
    "text_labels": "Rótulos de texto",
    "templates": "Modelos",
    "shape_and_colour": "Forma e cor",
    "line_colour": "Cor da linha",
    "fill_opacity": "Preencher a opacidade",
    "preview": "prévia",
    "width": "Largura",
    "offset": "Compensação",
    "zones": "Zonas",
    "list_of_options": "Lista de opções",
    "layer_design": "Design de camadas",
    "layer_templates": "Modelos de camadas",
    "view_all_templates": "Exibir todos os modelos de camadas",
    "scratch": "Comece uma camada do zero",
    "save_layer": "Salvar camada",
    "type_of_layer": "Tipo de camada",
    "styles": "Estilos",
    "save_style": "Salvar estilo",
    "more": "Mais",
    "Line": "Linha",
    "Icon": "Ícone",
    "Point": "Ponto",
    "Area": "Área",
    "layer_being_created": "A camada está sendo criada..."
  },
  "measurements": {
    "unit_of_measurement": "Unidade de medida",
    "imperial": "Imperial",
    "metric": "Métrico"
  },
  "sidebar": {
    "node_name": "O nome precisa ter pelo menos 2 caracteres"
  },
  "import_layers_tooltip": {
    "Layer": "A camada já existe neste plano"
  },
  "search": {
    "search_map": "Pesquisar",
    "locations": "Localizações",
    "objects": "Objetos",
    "search_description": "Pesquisar localização, visualização salva, objeto",
    "saved_map_view": "Visualizações salvas",
    "no_results": "Nenhum resultado correspondeu à sua consulta",
    "sitemaps": "Mapas do site"
  }
}